function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0453 39.3764H63.1807L59.4509 1.55102H46.3694L42.6395 39.3764H51.3425L51.6669 31.0008H53.721L54.0453 39.3764ZM48.1532 23.7599L51.9912 22.355L52.3155 13.439V10.1968H53.0723V13.439L53.4507 23.9761H48.1532V23.7599Z",
  fill: "#00B7B0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M76.7504 1.55102H61.6148V9.38628H64.8581V39.3764H73.5071V9.38628H76.7504V1.55102Z",
  fill: "#00B7B0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M87.9636 1.55102V16.411H82.558V16.1949L86.3419 14.7899V1.55102H77.693V39.3764H86.3419V23.9761H87.9636V39.3764H96.6125V1.55102H87.9636Z",
  fill: "#00B7B0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M98.0357 39.3764H111.279V31.5412H102.901V31.325L106.685 29.9201V1.55102H98.0357V39.3764Z",
  fill: "#00B7B0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M121.394 40.0248C127.07 40.0248 130.854 36.5665 130.854 31.379V9.54839C130.854 4.36091 127.07 0.902588 121.394 0.902588C115.718 0.902588 111.934 4.36091 111.934 9.54839V31.379C111.934 36.5665 115.718 40.0248 121.394 40.0248ZM121.394 32.1896C120.908 32.1896 120.583 31.8654 120.583 31.379V9.54839C120.583 9.06206 120.908 8.73785 121.394 8.73785C121.881 8.73785 122.205 9.06206 122.205 9.54839V31.379C122.205 31.8654 121.881 32.1896 121.394 32.1896Z",
  fill: "#00B7B0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M132.122 39.3764H140.771V27.8127L140.069 21.8687H140.879L141.582 27.8127L143.636 39.3764H152.772V1.55102H144.123V13.1148L144.826 19.0588H144.015L143.312 13.1148L141.258 1.55102H132.122V39.3764Z",
  fill: "#00B7B0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.345337 5.35451C0.345337 3.20307 2.08943 1.45898 4.24087 1.45898H34.4591C36.6105 1.45898 38.3546 3.20307 38.3546 5.35452V35.5727C38.3546 37.7242 36.6105 39.4682 34.4591 39.4682H4.24087C2.08942 39.4682 0.345337 37.7242 0.345337 35.5727V5.35451Z",
  fill: "#00B7B0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.0142 32.2696H32.5255L26.1729 26.3924C24.7069 26.3924 24.3771 24.7021 24.3771 24.4333V19.1781C24.3771 15.9222 21.7345 13.2738 18.4863 13.2738C15.2379 13.2738 12.5939 15.9222 12.5939 19.1781V20.4034C12.5939 23.6592 15.2379 26.3076 18.4863 26.3076C19.2222 26.3076 22.2636 26.3924 26.1729 26.3924L32.5255 32.2696C31.0595 32.2902 19.9628 32.2901 18.4863 32.2901C11.9465 32.2901 6.62646 26.958 6.62646 20.4034V19.1781C6.62646 12.6234 11.9465 7.29126 18.4863 7.29126C25.0261 7.29126 30.3459 12.6234 30.3459 19.1781V24.0949C30.3459 25.3145 30.5233 26.3924 32.5255 26.3924H33.0142V32.2696Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 41,
    viewBox: "0 0 153 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f98d2ca.svg";
export { ForwardRef as ReactComponent };